///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { KbTextBoxBaseComponent } from './../text-box.base.component';

@Component({
    selector: 'kb-text-area',
    templateUrl: './text-area.component.html',
})
export class KbTextAreaComponent extends KbTextBoxBaseComponent {
    @ViewChild('textArea')
    public textArea: ElementRef;
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/text-area/text-area.component.ts